export default __webpack_public_path__ + "static/media/SEC3030.34I-41289_-24631_0.f51cfdf7.jpg";